<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :createButtonDisabled="!$can('create','Patrimony')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PATRIMONY_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.patrimony;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(patrimony) {
      // console.log("PATRIMONY", patrimony, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(patrimony, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_PATRIMONY_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(patrimony, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createPatrimony.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createPatrimony.patrimony);
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PATRIMONY_QUERY = gql `
  {
    accountContext {
      patrimony {
        id
        patrimonyCategoryId
        patrimonyCategory {
          id
          name
          kind
        }
        brandId
        description
        enabled
        chassi
        hourlyPrice
        model
        plate
        year
        price
        serialNumber
        motorNumber
        potency
        observation
        insurancePolicyNumber
        insuranceExpirationDate
        renavan
        axesNumber
        grossWeight
        loadCapacity
        wheeledType
        bodyType
        bodywork
        tare
        colorId
        plateStateId
        workingMetricType
        workingMetricTypeValue
        validations
      }
    }
    globalContext {
      allPatrimonyCategories {
        id
        name
        kind
      }
      allStates {
        id
        name
        shortName
      }
      allColors {
        id
        name
        hexaCode
      }
      allWheeledTypes
      allBodyTypes
      allPatrimonyWorkingMetricTypes
    }
    accountGlobalSharedContext {
      allPatrimonyBrands {
        id
        name
      }
    }
  }
`;

const CREATE_PATRIMONY_MUTATION = gql `
  mutation($input: PatrimonyCreateInputObject!) {
    createPatrimony(input: $input) {
      patrimony {
        id
        patrimonyCategoryId
        patrimonyCategory {
          id
          name
          kind
        }
        brandId
        description
        chassi
        hourlyPrice
        model
        plate
        year
        price
        serialNumber
        motorNumber
        potency
        observation
        insurancePolicyNumber
        insuranceExpirationDate
        renavan
        axesNumber
        grossWeight
        loadCapacity
        bodywork
        tare
        colorId
        plateStateId
        workingMetricType
        workingMetricTypeValue
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!--
  createPatrimony(
  	input: {
      description: "desc",
      chassi: "chassi",
      hourlyPrice: 50,
      model: "model",
      plate: "plate",
      price: 50,
      brandId: 10,
      patrimonyCategoryId: 1,
      year: 2020
  }) {
    patrimony {
      id
    }
    errors
  }
 -->
